import '@midzer/tobii/dist/tobii.min.css';

if (document.querySelector('.js-lightbox')) {
  const { default: Tobii } = await import(
    /* webpackChunkName: "tobii" */ '@midzer/tobii'
  );

  const tobii = new Tobii({
    selector: '.js-lightbox',
    captions: false,
    closeLabel: 'Vergrößerung schließen',
    loadingIndicatorLabel: 'Bild lädt',
  });

  tobii.on('open', () => {
    window.dispatchEvent(new CustomEvent('lightbox:open'));
  });

  tobii.on('close', () => {
    window.dispatchEvent(new CustomEvent('lightbox:close'));
  });
}
